'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';

const FlagLgbtAsset = ({ width, height, ...props }, ref) => /* @__PURE__ */ jsxs(
  "svg",
  {
    viewBox: "0 0 28 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width,
    height,
    ref,
    "aria-hidden": true,
    ...props,
    children: [
      /* @__PURE__ */ jsx("path", { d: "M28 0H0V20H28V0Z", fill: "white" }),
      /* @__PURE__ */ jsx("path", { d: "M28 0H0V4H28V0Z", fill: "#F71E24" }),
      /* @__PURE__ */ jsx("path", { d: "M28 4H0L0 8H28V4Z", fill: "#FB6C2C" }),
      /* @__PURE__ */ jsx("path", { d: "M28 8H0V12H28V8Z", fill: "#FDFC42" }),
      /* @__PURE__ */ jsx("path", { d: "M28 12H0V16H28V12Z", fill: "#238F35" }),
      /* @__PURE__ */ jsx("path", { d: "M28 16H0L0 20H28V16Z", fill: "#0F62FA" })
    ]
  }
);
const VpFlagLgbtAsset = forwardRef(FlagLgbtAsset);

export { VpFlagLgbtAsset as default };
